import { useEffect, useState } from "react";

export const ScrollProgress = () => {
  const [w, setW] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setW(max > 0 ? (h.scrollTop / max) * 100 : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 z-[70] h-[2px] bg-[#B8894B] transition-[width] duration-150"
      style={{ width: `${w}%` }}
    />
  );
};
